if (!customElements.get('complementary-products')) {
	customElements.define('complementary-products', class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();

      this.onPriceModeChanged = this.onPriceModeChanged.bind(this);
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      if(this.querySelector('.complementary__actions')) {
        this.price = this.querySelector('.complementary__total__price');
        this.querySelectorAll('.select__select,input.complementary-variant-id[data-available="true"],.quantity__input').forEach(element => {
          element.addEventListener('change', this.onChangeHandler.bind(this));
        });
      }
      document.addEventListener('price:view-change', this.onPriceModeChanged);
      document.addEventListener('price:mode-change', this.onPriceModeChanged);
    }
    connectedCallback() {
      // Sync initial (cookie / dataset)
      this.onChangeHandler({ target: this });
    }

    disconnectedCallback() {
      document.removeEventListener('price:view-change', this.onPriceModeChanged);
      document.removeEventListener('price:mode-change', this.onPriceModeChanged);
    }

    onPriceModeChanged() {
      this.onChangeHandler({ target: this });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      
      let formData = {};
      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
      
      /* Collection items */
      let items = [];
      this.querySelectorAll('.complementary__item').forEach((item) => {
        const quantityInput = item.querySelector('.quantity__input');
        if(parseInt(quantityInput.value) > 0) {
          items.push({
            id: item.querySelector('.complementary-variant-id').value,
            quantity: quantityInput.value
          });
        }
      });
      formData.items = items;
      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          document.dispatchEvent(new CustomEvent('afterCartChanged'));
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    onChangeHandler(evt) {
      if(evt.target.classList.contains('select__select')) {
        const currentItem = evt.target.closest('.complementary__item');
        const itemAttributeTag = evt.target.querySelector('option:checked');
        //. this.updatePrice(currentItem.querySelector('.price'), parseInt(itemAttributeTag.dataset.price), parseInt(itemAttributeTag.dataset.compareAtPrice), true);
        // IMPORTANT : cibler le scope HT/TTC (custom element) en priorité
        const priceScope =
          currentItem.querySelector('product-price[data-price-scope]') ||
          currentItem.querySelector('product-price') ||
          currentItem.querySelector('.price');

        const nextPrice = parseInt(itemAttributeTag.dataset.price, 10) || 0;
        const nextCompare = parseInt(itemAttributeTag.dataset.compareAtPrice, 10) || 0;

        // Conserver le ratio HT/TTC issu du rendu Liquid courant
        const currentHt = parseInt(priceScope.dataset.priceHt || '0', 10);
        const currentTtc = parseInt(priceScope.dataset.priceTtc || '0', 10);
        const ratePlusOne = currentHt > 0 && currentTtc > 0 ? (currentTtc / currentHt) : 1;

        priceScope.dataset.priceHt = String(nextPrice);
        priceScope.dataset.priceTtc = String(Math.round(nextPrice * ratePlusOne));
        priceScope.dataset.compareHt = String(nextCompare);
        priceScope.dataset.compareTtc = String(Math.round(nextCompare * ratePlusOne));

        this.updatePrice(
          priceScope,
          nextPrice,
          nextCompare,
          true
        );

        // Après update, le DOM interne peut changer : on force une ré-application du mode courant
        const currentView = (document.documentElement.dataset.priceView || 'ttc');
        document.dispatchEvent(new CustomEvent('price:view-change', { detail: { view: currentView } }));


        const imageTag = currentItem.querySelector('img');
        if(itemAttributeTag.dataset.featuredImage) {
          let srcset = '';
          const imageWidth = parseInt(itemAttributeTag.dataset.featuredImageWidth);
          const originImageSrc = itemAttributeTag.dataset.featuredImage;
          const widths = [275, 550, 710, 1420];
          widths.forEach(width => {
            if(imageWidth >= width) {
              srcset += `${originImageSrc}&width=${width} ${width}w,`;
            }
          });
          srcset += `${originImageSrc} ${imageWidth}w`;
          imageTag.srcset = srcset;
          imageTag.classList.add('use-variant-image');
        } else if(imageTag.classList.contains('use-variant-image')){
          imageTag.srcset = currentItem.dataset.featuredImage;
          imageTag.classList.remove('use-variant-image');
        }
      } 
      let totalHt = 0, totalTtc = 0;
      let totalCompareHt = 0, totalCompareTtc = 0;
      let totalQuantity = 0;
      this.querySelectorAll('.complementary__item').forEach((item) => {
        const qtyInput = item.querySelector('.quantity__input');
        if (!qtyInput) return;
        const quantity = parseInt(qtyInput.value || '0', 10);
        if (quantity <= 0) return;

        // Le prix affiché (déjà calculé Liquid) est dans <product-price>
        const priceEl = item.querySelector('product-price[data-price-scope]');
        if (!priceEl) return;

        const unitHt  = parseInt(priceEl.dataset.priceHt  || '0', 10);
        const unitTtc = parseInt(priceEl.dataset.priceTtc || '0', 10);

        const unitCompareHt  = parseInt(priceEl.dataset.compareHt  || '0', 10);
        const unitCompareTtc = parseInt(priceEl.dataset.compareTtc || '0', 10);
        totalQuantity += quantity;
        totalHt  += unitHt  * quantity;
        totalTtc += unitTtc * quantity;
        totalCompareHt  += unitCompareHt  * quantity;
        totalCompareTtc += unitCompareTtc * quantity;
      });
      if (this.price) {
        this.updateComplementaryTotal(this.price, {
          ht: totalHt,
          ttc: totalTtc,
          compareHt: totalCompareHt,
          compareTtc: totalCompareTtc
        });
      }
      if(this.submitButton) {
        if(totalQuantity > 0) {
          this.submitButton.removeAttribute('disabled');
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
        }
      }
    }

    updatePrice(priceElement, price, compareAtPrice, noConvert) {
      priceElement.update(price, compareAtPrice, noConvert);
    }

    updateComplementaryTotal(totalPriceEl, totals) {
      // totalPriceEl = <product-price data-price-scope ...> (après correction Liquid)
      totalPriceEl.dataset.priceHt = String(totals.ht || 0);
      totalPriceEl.dataset.priceTtc = String(totals.ttc || 0);
      totalPriceEl.dataset.compareHt = String(totals.compareHt || 0);
      totalPriceEl.dataset.compareTtc = String(totals.compareTtc || 0);

      // Laisse le custom element gérer le rendu HTML (avec le suffixe HT/TTC)
      if (typeof totalPriceEl.update === 'function') {
        totalPriceEl.update(totals.ttc || 0, totals.compareTtc || 0, true);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
